/** Resolve the exact call reference, keeping latest and pinned entries independent. */
export const findWorkflowFunction = ({ step, workflowFunctions = [] }) => {
  return workflowFunctions.find((workflow) => workflow?.id === step?.functionId && (workflow.functionSnapshotId ?? null) === (step?.options?.functionSnapshotId ?? null));
};
